export default __webpack_public_path__ + "static/media/agro-color.9edd8a44.svg";